<div class="position-absolute bottom-7 start-20">
  <app-scale-control> </app-scale-control>
</div>

<app-bottom-page-panel>
  <app-history-mode
    *hasPermissionAny="[Permissions.RCS_Historic_All_Read]"
    [isHistoryVisible]="isHistoryVisible"
    (historyToggled)="toggleHistory()"
    data-cy="historic-view-toggle"
  ></app-history-mode>
  <app-auto-refresh
    (intervalSet)="setLiveModeRefreshInterval($event)"
    [isActive]="isInLiveMode"
    [isDisabled]="isHistoryVisible"
    [intervalInSecondsInput]="displayRefreshInterval"
  ></app-auto-refresh>
</app-bottom-page-panel>

<app-rc-layer-config [providerInfo$]="this.ProviderInfo$"></app-rc-layer-config>
<app-rc-legend [providerInfo$]="this.ProviderInfo$" *ngIf="isLegendVisible"></app-rc-legend>
<app-rc-details></app-rc-details>
<app-rc-raw-details></app-rc-raw-details>
<app-rc-details-weather></app-rc-details-weather>
<app-map-navigation>
  <app-rc-view-actions-bar
    [isLegendVisible]="isLegendVisible"
    (toggleLegend)="toggleLegend()"
  ></app-rc-view-actions-bar>
</app-map-navigation>
<app-rc-history-control
  (historyClosed)="handleHistoryClosed()"
  *ngIf="isHistoryVisible"
></app-rc-history-control>
<app-last-backend-call></app-last-backend-call>
